import {createSlice} from "@reduxjs/toolkit";

export const selectedFilters = createSlice({
  name: 'selectedFilters',
  initialState: [],
  reducers: {
    setFilters: (state: any, {payload}) => payload,
  }
})

export const {setFilters} = selectedFilters.actions
export default selectedFilters.reducer